import React from "react";
import styles from "./CustomHeader.module.scss";
import Button from "../Button/Button";
import SearchIcon from "../SVGComponents/SearchIcon";
import PlusIcon from "../SVGComponents/PlusIcon";
import FilterIcon from "../SVGComponents/FilterIcon";
import CrossIcon from "../SVGComponents/CrossIcon";

interface CustomHeaderProps {
  title?: string;
  search?: string | null;
  setSearch?: React.Dispatch<React.SetStateAction<string | null>>;
  searchPlaceholder?: string;
  onFilterClick?: () => void;
  filterContent?: React.ReactNode;
  buttonLabel?: string;
  onButtonClick?: () => void;
}
const CustomHeader: React.FC<CustomHeaderProps> = ({
  title,
  search,
  setSearch,
  searchPlaceholder = "Search",
  onFilterClick,
  filterContent,
  buttonLabel,
  onButtonClick,
}) => {
  const onSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch?.(e.target.value);
  };

  return (
    <div className={styles.topSection}>
      {title && <h1 className={styles.pageTitle}>{title}</h1>}
      <div className={styles.rightSection}>
        {setSearch && (
          <div className={styles.filterSearch}>
            <span className={styles.search}>
              <SearchIcon className={styles.searchIcon} />
              <input
                value={search ?? ""}
                onChange={onSearchChange}
                type="text"
                placeholder={searchPlaceholder}
              />
              {search && (
                <button
                  type="button"
                  className={styles.clearSearch}
                  onClick={() => setSearch?.("")}
                  aria-label="Clear search"
                >
                  <CrossIcon />
                </button>
              )}
            </span>
            {(onFilterClick || filterContent) && (
              <div className={styles.filterWrapper}>
                <Button
                  className={styles.filter}
                  onClick={onFilterClick}
                  outlined={true}
                >
                  Filter
                  <FilterIcon />
                </Button>
                {filterContent && (
                  <div className={styles.filterDropdown}>{filterContent}</div>
                )}
              </div>
            )}
          </div>
        )}
        {onButtonClick && (
          <Button
            onClick={onButtonClick}
            className={styles.button}
            outlined={false}
            
          >
            <PlusIcon className={styles.plusicon} />
            {buttonLabel}
          </Button>
        )}
      </div>
    </div>
  );
};

export default CustomHeader;
